import BaseModel from './base';

export default class EventTemplate extends BaseModel {
  constructor(template, url) {
    super(template, url);

    this.event_id = template.event_id;
    this.is_usage = template.is_usage;
    this.level = template.level;
    this.main_event_id = template.main_event_id;

    /** Object<{ (event | event_options | stages | stages_options | subordination): Item }>
     * Item<{ data: Data[], id: Number }>
     * Data<{ field: String, can_user_update: Boolean, can_cascade_update: Boolean }>
     *
     * ex. template: {
     *  event: {
     *    data: [{ field: "name", can_user_update: true, can_cascade_update: true }, …]
     *    id: id
     *  },
     *  …
     * }
     */
    this.template = template.template || null;
    this.template_event_id = template.template_event_id;
  }
}
